import { useCallback } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Notice } from '.';

const NoticeContainer = () => {
  const { dispatch } = useDispatch();

  const { notices } = useReduxState();

  const handleDismiss = useCallback(
    (id: number) => dispatch.dismissNotice(id),
    [dispatch]
  );

  return (
    <div className="notices">
      {notices.map((notification) => (
        <Notice
          dismissAfter={
            notification.dismissAfter ??
            (notification.type === 'success' ? 4000 : 0)
          }
          key={notification.id}
          id={notification.id}
          link={notification.link}
          onDismiss={handleDismiss}
          text={notification.text}
          type={notification.type}
        />
      ))}

      <style jsx>{`
        .notices {
          max-width: calc(100% - 50px);
          position: fixed;
          top: 25px;
          right: 25px;
          width: 100%;
          z-index: 230;
        }
        @media (min-width: ${breakpoints.small}px) {
          .notices {
            max-width: 360px;
          }
        }
      `}</style>
    </div>
  );
};

export default NoticeContainer;
